const req = require.context('./', true, /(.+\/)(?!index)\w+\.[jt]s$/);
req.keys().forEach(file => {
    const f = req(file);
    module.exports[file.replace(/^(.*\/)?(\w+).[jt]s$/, '$2')] = f.default || f;
});
delete module.exports.default;
